import React, { useEffect, useState } from 'react'

import * as location from '~/constants/location'
import Select from '~/components/Select'
import Textarea from '~/components/Textarea'
import PhoneInput from '~/components/PhoneInput'
import Field from './Field'
import OpenHoursField from './OpenHoursField'
import WebsiteField from './WebsiteField'
import SpecialHoursField from './SpecialHoursField'
import PrimaryAdditionalPhoneField from './PrimaryAdditionalPhoneField'
import LabelInput from './LabelInput'
import { Container, Form } from './styles'
import useAxios from 'axios-hooks'
import PrimaryAdditionalCategories from './PrimaryAdditionalCategories'
import { formatPhoneNumberIntl } from 'react-phone-number-input'

function GeneralInfoForm({ formik, removeLabels, onChangeRemoveLabels }) {
  const [editableFields, setEditableFields] = useState({})
  const [locationCategories, setLocationCategories] = useState([])

  const [, fetchCategories] = useAxios('/locations/categories')

  const fillCategoriesData = React.useCallback(async () => {
    const { data } = await fetchCategories()
    const categoryOptions = data.categories
      ?.map(({ name, displayName }) => ({
        label: displayName,
        value: { name: name?.replace('categories/', ''), displayName },
      }))
      .sort(({ label: a }, { label: b }) => a.localeCompare(b))

    setLocationCategories(categoryOptions)
  }, [fetchCategories])

  useEffect(() => {
    fillCategoriesData()
  }, [fillCategoriesData])

  const handleSwitchChange = switchId => {
    setEditableFields(prevState => ({
      ...prevState,
      [switchId]: !editableFields[switchId],
    }))
  }

  const defaultProps = {
    onSwitchChange: handleSwitchChange,
    editableFields: editableFields,
    controller: formik,
  }

  return (
    <Container>
      <Form>
        <Field
          {...defaultProps}
          name="title"
          label="Location name"
          enableVariables
        />
        <PrimaryAdditionalCategories
          {...defaultProps}
          label="Categories"
          options={locationCategories}
        />
        <Field
          {...defaultProps}
          name="openInfo.status"
          label="Location status"
          options={location.openInfoStatusOptions}
          placeholder=""
          type="select"
          render={props => (
            <Select
              {...props}
              isDisabled={props.disabled}
              menuPortalTarget={document.querySelector('body')}
            />
          )}
        />
        <WebsiteField {...defaultProps} name="websiteUri" label="Website" />
        <PrimaryAdditionalPhoneField {...defaultProps} label="Phone number" />
        <Field
          {...defaultProps}
          name="adWordsLocationExtensions.adPhone"
          label="Google Ads number"
          render={PhoneInput}
          className="form-control"
          onChange={value =>
            formik.setFieldValue(
              'adWordsLocationExtensions.adPhone',
              formatPhoneNumberIntl(value)
            )
          }
        />
        <Field
          {...defaultProps}
          name="labels"
          label="Labels"
          removeLabels={removeLabels}
          onChangeRemoveLabels={onChangeRemoveLabels}
          render={LabelInput}
          valueExtractor={v => v}
        />
        <OpenHoursField
          {...defaultProps}
          name="regularHours.periods"
          label="Open hours"
        />
        <SpecialHoursField
          {...defaultProps}
          name="specialHours.specialHourPeriods"
          label="Special hours"
        />
        <Field
          {...defaultProps}
          name="profile.description"
          label="Location Description"
          onChange={(e, { setValue }) => setValue(e?.target?.value)}
          render={Textarea}
          maxLength={750}
          enableVariables
        />
      </Form>
    </Container>
  )
}

export default GeneralInfoForm
